<template xmlns="http://www.w3.org/1999/html">
  <div class="renewDialog">
    <el-dialog title="续费资源接口服务" custom-class="renew-interface-manager-dialog" :visible.sync="renewDialogVisible" :close-on-click-modal="false">
      <el-form ref="renewForm" :model="renewForm" :rules="rules" label-width="120px">
        <el-form-item label="开通时段" class="is-required" prop="endTime" v-if="renewData.type == 1">
          <el-date-picker type="date"
            placeholder="选择过期日期"
            v-model="renewForm.endTime"
            style="width: 100%;"
            value-format="yyyy-MM-dd"
            :picker-options="pickerDate"
            :editable="false">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="接口调用限制"  class="is-required" prop="invokeLimit" v-if="renewData.type == 2">
          <el-input v-model.number="renewForm.invokeLimit" :disabled="renewData.apiResourceDto.id == 1"></el-input>
        </el-form-item>

        <el-form-item label="去重下载限制"  class="is-required" prop="downloadLimit" v-if="renewData.type == 2">
          <el-input v-model.number="renewForm.downloadLimit" :disabled="renewData.apiResourceDto.id == 1"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="renewDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="openit()" v-loading="loading">开通</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import devService from '@/service/devService'
export default {
  props: {
    renewData: {
      type: Object
    },
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    let validateData = (rule, value, callback) => {
      if (this.renewData.type == '1') {
        if (!value) {
          callback(new Error('请选择时段'))
        }
      }
      callback()
    }

    let invokeLimitValid = (rule, value, callback) => {
      if (this.renewData.type == '2' && this.renewData.apiResourceDto.id != 1) {
        if (value === '') {
          callback(new Error('请输入接口数量'))
        } else if (value <= 0) {
          callback(new Error('续费接口数量必须大于0'))
        }
      }
      callback()
    }

    let validateeliteLimit = (rule, value, callback) => {
      if (this.renewData.type == '2') {
        if (!value) {
          callback(new Error('请输入接口数量'))
        } else if (value <= 0) {
          callback(new Error('续费接口数量必须大于0'))
        }
      }
      callback()
    }

    let downloadLimitValid = (rule, value, callback) => {
      if (this.renewData.type == '2' && this.renewData.apiResourceDto.id != 1) {
        console.log(111)
        if (value === '') {
          callback(new Error('请输入接口数量'))
        } else if (value <= 0) {
          callback(new Error('开通接口数量必须大于等于0'))
        }
      }
      callback()
    }

    return {
      loading: false,
      rules: {
        endTime: [
          {validator: validateData, trigger: ['blur', 'change']}
        ],
        downloadLimit: [
          {validator: downloadLimitValid, trigger: ['blur', 'change']}
        ],
        invokeLimit: [
          {validator: invokeLimitValid, trigger: ['blur', 'change']}
        ]
      },
      pickerDate: {
        disabledDate: time => {
          return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000
        }
      },
      renewForm: {
        endTime: '',
        invokeLimit: '',
        downloadLimit: ''
      }
    }
  },
  mounted () {
    // 加载用户开通信息
    // console.log(this.$props.renewData)
  },
  methods: {
    openit () {
      this.loading = true
      this.$refs.renewForm.validate(async valid => {
        // 验证通过
        if (valid) {
          // let downloadlimit = this.renewForm.downloadLimit
          if (this.renewData.apiResourceDto.id == 1) {
            this.renewForm.downloadLimit = -1
            this.renewForm.invokeLimit = -1
          }
          try {
            // this.renewData.userId = this.id
            await devService.renewDev({
              type: this.renewData.type,
              status: this.renewData.status,
              startTime: this.renewData.startTime,
              endTime: this.renewForm.endTime,
              userId: this.renewData.userId,
              invokeLimit: this.renewForm.invokeLimit,
              downloadLimit: this.renewForm.downloadLimit,
              resourceId: this.renewData.apiResourceDto.id
            })
            this.$message.success(this.SysConstant.success)
            this.$emit('success')
            this.renewDialogVisible = false
          } catch (e) {
            this.$message.error(e && e.msg)
          }
        }
      })
      this.loading = false
    }
  },
  watch: {
    renewDialogVisible (newVal, oldVal) {
      if (newVal) {
        if (this.$refs.renewForm) {
          this.$refs.renewForm.resetFields()
        }
      }
      // this.renewData = {
      //   endTime: this.$props.renewData.endTime
      // }
    }
  },
  computed: {
    renewDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>

</style>
<style type="text/css">

  .renewDialog .renew-interface-manager-dialog{
    width: 500px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/admin/interface-manage/renew-dialog/index.vue